import { ReactNode } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { modalTypes } from 'src/constants/modalTypes';
import { showModal } from 'src/modules/shared/modal/actions';
import { State } from 'src/types';

export const useModal = (modalType: modalTypes, modalComponent: ReactNode) => {
  if (useSelector(({modal}: State) => modal.modalType) === modalType) {
    return modalComponent;
  }
};

export const useModalTrigger = (modalType: modalTypes, modalProps?: any) => {
  const dispatch = useDispatch();
  return () => dispatch(showModal({ modalType, modalProps }));
};
